/**
 * Enum値の定数値を設定
 * 各コンポーネントではmixinとして呼び込む
 * なお、同名の定数値がすでに存在した場合、そちらが優先されるので注意
 */
var enumMixin = {
  data: function () {
    return {

      EnumUserTypeAdminUser: 1,
      EnumUserTypeWinner: 2,

      EnumAwardTypeTcc10Sen2021: 1,
      EnumAwardTypeTcc10Sen2020: 2,
      EnumAwardTypeTcc10Sen2019: 3,
      EnumAwardTypeTcc10Sen2018: 4,
      EnumAwardTypeTcc10Sen2017: 5,
      EnumAwardTypeTcc10Sen2016: 6,
      EnumAwardTypeTcc10Sen2015: 7,
      EnumAwardTypeTcc10Sen2014: 8,
      EnumAwardTypeTcc10Sen2013: 9,
      EnumAwardTypeTcc10Sen2012: 10,
      EnumAwardTypeJapan100Views: 11,
      EnumAwardTypeCastleAndMoon: 12,

      EnumAwardTypeWeibo: 13,
      EnumAwardTypeJtg: 14,
      EnumAwardTypeTwitter: 15,
      EnumAwardTypeSpecialExhibitons: 16,
      EnumAwardTypeInstagram: 17,
      EnumAwardTypeMonogatary: 18,
      EnumAwardTypeTcc: 9999,

      EnumCommentStatusUnchecked: 1,
      EnumCommentStatusPublic: 2,
      EnumCommentStatusPrivate: 3,

      EnumCommentTypeWinner: 1,
      EnumCommentTypeWinningWork: 2,
      EnumCommentTypePortfolio: 3,

      EnumHighResolutionTypeResolution6000: 1,
      EnumHighResolutionTypeResolution4000: 2,
      EnumHighResolutionTypeResolution2048: 3

    }
  }
}

export default enumMixin
